import { render, staticRenderFns } from "./PeriodDetail.vue?vue&type=template&id=05289f62&scoped=true&"
import script from "./PeriodDetail.vue?vue&type=script&lang=js&"
export * from "./PeriodDetail.vue?vue&type=script&lang=js&"
import style0 from "./PeriodDetail.vue?vue&type=style&index=0&id=05289f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05289f62",
  null
  
)

export default component.exports